import React, { useEffect, useState } from "react";
import axios from "axios";
import { useLocation, useNavigate } from "react-router-dom";
import moment from "moment";
import eye from "../../assets/eye.png";
import { createColumnHelper } from "@tanstack/react-table";
import ReactTable from "../../components/ReactTable";
import CustomPagination from "../../components/CustomPagination";
import { useSelector } from "react-redux";
export const base_url = process.env.REACT_APP_BASE_URL;
export const api_type = process.env.REACT_APP_API_TYPE;

function InvestorDetails() {
  const navigate = useNavigate();
  const [investorUserDetails, setInvestorUserDetails] = useState([]);
  const [investmentsDetails, setInvestmentsDetails] = useState([]);

  const { userPermissionData } = useSelector((state) => state.userPermission);

  // const [page, setPage] = useState(1);
  const [page, setPage] = useState(() => {
    const savedPage = localStorage.getItem('investorDetailsPage');
    return savedPage ? Number(savedPage) : 1;
  });
  const [total, setTotal] = useState(0);
  const [pageSize, setPazeSize] = useState(0);
  const [searchInput, setSearchInput] = useState("");
  const [searchInputApi, setSearchInputApi] = useState("");
  const [error, setError] = useState(null);
  const location = useLocation();
  const id = location?.state?.uniqueId;
  console.log("searfh", searchInput);
  const fetchInvestorDetails = async () => {
    const endpoint = `${base_url}/${api_type}/investments/investor/${id}`;

    try {
      const response = await axios.get(endpoint, {
        headers: {
          Authorization: `Bearer ${localStorage.getItem("token")}`,
        },
        params: {
          search: searchInputApi,
          page: page,
        },
      });
      setInvestorUserDetails(response?.data?.data?.userDetails);
      setInvestmentsDetails(response?.data?.data?.investments);
      setPage(response?.data?.data?.pagination?.currentPage);
      setTotal(response?.data?.data?.pagination?.totalRecords);
      setPazeSize(response?.data?.data?.pagination?.perPage);
    } catch (err) {
      console.error("Failed to fetch pending orders:", err);
      setError(err.message);
    }
  };
  useEffect(() => {
    fetchInvestorDetails();
  }, [searchInputApi, page]);

  const columnHelper = createColumnHelper();

  const columns = [
    columnHelper.accessor("id", {
      cell: (info) => info.renderValue(),
      header: () => <span>Bond Id</span>,
    }),
    columnHelper.accessor("name", {
      cell: (info) => (info.renderValue() ? `${info.renderValue()}` : "N/A"),
      header: () => (
        <div className=" ">
          <span>Bond Name</span>
        </div>
      ),
    }),
    columnHelper.accessor("name", {
      cell: (info) => (info.renderValue() ? `${info.renderValue()}` : "N/A"),
      header: () => (
        <div className=" ">
          <span>Interest</span>
        </div>
      ),
    }),
    columnHelper.accessor("investmenDate", {
      cell: (info) => {
        let createdAt = info?.getValue();
        createdAt = createdAt ? moment(createdAt).format("DD-MM-YYYY") : "N/A";
        return createdAt;
      },
      header: () => <span>Investment Date</span>,
    }),
    columnHelper.accessor("status", {
      cell: (info) => {
        const status = info?.row?.original?.status;
        return (
          <div
            className={`w-[27px] h-[27px] py-1 flex rounded text-center text-sm ${
              status === "invested" ? "text-[#31A653]" : "text-[#FFB819]"
            }`}
          >
            {status}
          </div>
        );
      },
      header: () => <span>Status</span>,
    }),
  ];

  const handleSearchInputChange = (e) => {
    const value = e.target.value;
    setSearchInput(value);
    
    if (!value.trim()) {
      setSearchInputApi('');
    }
  };

  const handleSearchClick = () => {
    setPage(1);
    setSearchInputApi(searchInput);
  };

  const downloadInvestorDetails = async () => {
    const endpoint = `${base_url}/${api_type}/investments/investor/export-to-excel/${id}`;
    try {
      const response = await axios.get(endpoint, {
        headers: {
          Authorization: `Bearer ${localStorage.getItem("token")}`, // Replace 'your-auth-token' with the actual token
        },
        params: {
          search: searchInput, // Pass `searchInput` as a query parameter
        },
        responseType: "blob",
      });

      // Create a blob from the response data
      const blob = new Blob([response.data], {
        type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
      });

      // Create a temporary link to trigger the download
      const link = document.createElement("a");
      link.href = URL.createObjectURL(blob);
      link.download = "investor_details.xlsx"; // Provide a default file name

      // Append the link to the document and trigger the click
      document.body.appendChild(link);
      link.click();

      // Clean up the link and blob URL
      document.body.removeChild(link);
      URL.revokeObjectURL(link.href);

      console.log("File downloaded successfully!");
      console.log(response, "response-download");
    } catch (err) {
      console.error("Failed to fetch pending orders:", err);
      setError(err.message);
    }
  };
  const onDownloadClick = () => {
    downloadInvestorDetails();
  };

  return (
    <>
      <div className="w-full mt-20 md:pl-5">
        <div>
          <button
            onClick={() => window.history.back()}
            className="border-none bg-transparent text-gray-700 text-sm font-bold cursor-pointer py-2.5"
          >
            ← Back to Investor
          </button>
        </div>

        <div className="bg-white rounded-lg mt-3 mb-5 w-full font-bold border border-1 border-gray-300 pt-5">
          <h2 className="text-md font-bold px-5 py-2.5">Investor Details</h2>
          <div className="border-b border-1 border-gray-300 pb-2"></div>
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5 p-5">
            <div>
              <label className="text-gray-600 text-xs block mb-1.5">
                UCC Code
              </label>
              <input
                type="text"
                disabled={true}
                placeholder=""
                className="bg-gray-50 p-2.5 rounded w-full text-sm text-gray-600 border-none"
              />
            </div>
            <div>
              <label className="text-gray-600 text-xs block mb-1.5">
                Investor Name
              </label>
              <input
                type="text"
                placeholder="John Smith"
                disabled={true}
                value={investorUserDetails?.name}
                className="bg-gray-50 p-2.5 rounded w-full text-sm text-gray-600 border-none"
              />
            </div>
            <div>
              <label className="text-gray-600 text-xs block mb-1.5">
                Settlement Date
              </label>
              <input
                type="text"
                placeholder=""
                disabled={true}
                value={investorUserDetails?.settlementDate}
                className="bg-gray-50 p-2.5 rounded w-full text-sm text-gray-600 border-none"
              />
            </div>
            <div>
              <label className="text-gray-600 text-xs block mb-1.5">
                Last Invested
              </label>
              <input
                type="text"
                placeholder="15/11/2024"
                disabled={true}
                value={
                  investorUserDetails?.lastInvested
                    ? moment(investorUserDetails?.lastInvested).format(
                        "DD/MM/YYYY"
                      )
                    : "N/A"
                }
                className="bg-gray-50 p-2.5 rounded w-full text-sm text-gray-600 border-none"
              />
            </div>
            <div>
              <label className="text-gray-600 text-xs block mb-1.5">
                Total Amount Invested
              </label>
              <input
                type="text"
                disabled={true}
                placeholder="₹850,000"
                value={`₹ ${investorUserDetails?.totalInvestedAmount}`}
                className="bg-gray-50 p-2.5 rounded w-full text-sm text-gray-600 border-none"
              />
            </div>
          </div>
        </div>
        <div className="flex flex-wrap justify-between items-center mb-3 w-full font-bold text-nowrap gap-3">
          <h2>Investment Details</h2>
          <div className="flex flex-wrap gap-2.5 w-full sm:w-auto">
            <div className="flex gap-0.5 flex-grow">
              <input
                type="text"
                value={searchInput}
                onChange={handleSearchInputChange}
                placeholder="Search by Bond ID/Bond Name"
                className="px-3 py-2 border border-gray-300 rounded-tl-[10px] rounded-bl-[10px] w-full max-w-[300px]"
              />
              <button
                onClick={handleSearchClick}
                className="bg-[#0066b2] text-white border-none px-4 py-2 rounded-tr-[10px] rounded-br-[10px] cursor-pointer"
              >
                Search
              </button>
            </div>
            {userPermissionData?.investment?.download && (
              <button
                onClick={onDownloadClick}
                className="bg-white border border-[#0066b2] text-[#0066b2] px-4 py-2 rounded-[10px] cursor-pointer flex items-center gap-2"
              >
                Download <i className="fas fa-arrow-down"></i>
              </button>
            )}
          </div>
        </div>

        <div className="w-full font-poppins overflow-x-auto bg-white p-4">
          <ReactTable
            key={JSON?.stringify(investmentsDetails)}
            defaultData={investmentsDetails}
            columns={columns}
          />
        </div>

        {investmentsDetails?.length > 0 && (
          <div className="w-full flex justify-center mt-4">
            <CustomPagination
              currentPage={page}
              setCurrentPage={setPage}
              totalItems={total}
              itemsPerPage={pageSize}
              maxPageNumbersToShow={5}
              storageKey="investmentDetailsPage"
            />
          </div>
        )}
      </div>
    </>
  );
}

export default InvestorDetails;
